import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import Select from "../../Select";
import { IRowsProps } from "./types";

import "./styles.scss";

export const Rows: FC<IRowsProps> = ({ pageSizes, onPageSizeChange }) => {
  const { t } = useTranslation();

  return (
    <div className="ams-rows">
      {t("resultsPerPage")}
      <Select className="ams-rows__select" onChange={onPageSizeChange}>
        {pageSizes.map((item: number) => {
          return (
            <option key={item} value={item}>
              {item}
            </option>
          );
        })}
      </Select>
    </div>
  );
};
